import { atom, selector, selectorFamily } from 'recoil';
import produce from 'immer';

import { getJobs, getClients, getJobInfo } from '../../repositories/HttpRepository';

export const timestampState = atom({
  key: 'job_timestamp',
  default: new Date(),
});

export const filtersState = atom({
  key: 'job_filtersState',
  default: {
    start: 0,
    size: 50,
  },
});

export const filtersSelectorFamily = selectorFamily({
  key: `job-filtersSelectorFamily`,
  set:
    (name) =>
    ({ get, set }, newValue) => {
      const filters = get(filtersState);
      // console.log('v', filters, name, newValue);
      set(
        filtersState,
        produce(filters, (draft) => {
          draft[name] = newValue;
        }),
      );
    },
});

// export const jobDataState = atom({
//   key: 'job_jobDataState',
//   default: {},
// });

export const jobDataState = selector({
  key: 'job_jobDataState',
  get: async ({ get }) => {
    const timestamp = get(timestampState);
    const filters = get(filtersState);
    const response = await getJobs(filters);

    return response.data;
  },
});

export const pageInfoSelector = selector({
  key: 'job_pageInfoState',
  get: ({ get }) => {
    const jobData = get(jobDataState);
    return produce(jobData, (draft) => {
      draft.items = undefined;
    });
  },
});

// export const clientsState = atom({
//   key: 'job_clientsState',
//   default: [],
// });

export const clientsSelector = selector({
  key: 'job_jclientsSelector',
  get: async ({ get }) => {
    const response = await getClients();
    return response.data;
  },
});

export const jobsState = selector({
  key: 'job_jobsState',
  get: ({ get }) => {
    const jobData = get(jobDataState);
    const clients = get(clientsSelector);

    if (!jobData?.items || jobData.items.length <= 0) return [];

    if (!clients || clients.length <= 0)
      return jobData.items.map((i) => {
        return produce(i, (draft) => {
          draft.client_name = draft.client_id;
        });
      });

    // process client
    const clientMap = clients.reduce((map, c) => {
      map[c.id] = c;
      return map;
    }, {});

    return jobData.items.map((i) => {
      return produce(i, (draft) => {
        draft.client_name = clientMap[draft.client_id] ? `${clientMap[draft.client_id].company} - ${draft.client_id}` : draft.client_id;
      });
    });
  },
  set: ({ get, set }, data) => {
    // console.log('set data: ', data);
    set(jobDataState, data);
  },
});

export const jobInfoSelector = selectorFamily({
  key: 'job_jobInfoSelector',
  get: (jobId) => async () => {
    const response = await getJobInfo(jobId);
    if (response.error) {
      throw response.error;
    }

    return response.data;
  },
});

export const jobClientInfo = selectorFamily({
  key: 'job_jobClientInfo',
  get:
    (jobId) =>
    async ({ get }) => {
      const clients = get(clientsSelector);
      const clientMap = clients.reduce((map, c) => {
        map[c.id] = c;
        return map;
      }, {});

      const info = get(jobInfoSelector(jobId));
      if (!info?.job) return null;

      return clientMap[info.job.client_id];
    },
});
